import {useCallback, useState} from 'react'

export const useToggle = (defaultStatus = false) => {
    const [isActive, setIsActive] = useState(defaultStatus)
    const on = useCallback(() => setIsActive(true), [])
    const off = useCallback(() => setIsActive(false), [])
    const toggle = useCallback(() => setIsActive(prev => !prev), [isActive])

    return {isActive, on, off, toggle}
}
